module.exports = __webpack_public_path__ + "assets/prev-arrow-blue.svg?ver=8ee338ae";